var root = require('./_root');

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;



//////////////////
// WEBPACK FOOTER
// /exlibris/product/npm_modules/release-URM/prima/node_modules/lodash/_Symbol.js
// module id = 97
// module chunks = 6